<template>
  <div>
    <v-data-table
      :headers="visualizarPontosMedalha ? headers : headersSemPontos"
      :items="perguntasEvidenciadas"
      class="elevation-1"
      hide-default-footer
      disable-pagination
      :expanded.sync="expanded"
      item-key="perguntaMunicipioId"
    >
      <template v-slot:item="props">
        <tr>
          <td>
            {{ props.item.nome }}
          </td>
          <td>
            <div>
              <div>{{ props.item.texto }}</div>
            </div>
          </td>
          <td v-if="criterio5Ativo && !(user && user.grupo && user.grupo.usuarioGrupoId == 7) && props.item.perguntaId == 3 &&
            (isFullAdmin || (groupsConfig.visualizarEvidenciadas && config.visualizarEvidenciadas))">
            <v-btn color="azulclarosc" dark class="ml-3" @click="abrirCriterio5(props.item)">
              Avaliar critério 05
            </v-btn>
          </td>
          <td v-else-if="props.item.temArquivo" @click="() => $emit('openEvidence', props.item)">
            <div class="optionsExpanded">
              <v-btn
                color="azulclarosc"
                class="ml-3"
                style="color: #fff"
                v-if="
                  isFullAdmin ||
                  (groupsConfig.visualizarEvidenciadas &&
                    config.visualizarEvidenciadas)
                "
              >
                <span
                  v-if="
                    expanded.length > 0 &&
                    props.item.perguntaMunicipioId ===
                      expanded[0].perguntaMunicipioId
                  "
                  >esconder arquivos</span
                >
                <span v-else>mostrar arquivos</span>
              </v-btn>
            </div>
          </td>

          <td v-else></td>
          <td style="display: flex; align-items: center; width: 100%">
            <template
              v-if="
                isFullAdmin ||
                !isSala ||
                (isSala &&
                  JSON.parse(config.visualizaEixosIds || '[]').includes(
                    props.item.eixoId
                  ))
              "
            >
              <v-file-input
                v-if="!consultaSomenteLeitura(props.item) && (
                  isFullAdmin ||
                  (groupsConfig.enviarEvidenciadas && config.enviarEvidenciadas)
                )"
                multiple
                :accept="getFileAccept(props.item.perguntaId)"
                label="Selecione Arquivos de Evidência"
                v-model="props.item.arquivos"
                @change="(files) => validateFiles(files, props.item)"
              >
              </v-file-input>
            </template>
            <template
              v-if="
                isFullAdmin ||
                !isSala ||
                (isSala &&
                  JSON.parse(config.visualizaEixosIds || '[]').includes(
                    props.item.eixoId
                  ))
              "
            >
              <v-btn
                v-if="!consultaSomenteLeitura(props.item) && (
                  isFullAdmin ||
                  (groupsConfig.enviarEvidenciadas && config.enviarEvidenciadas)
                )"
                color="primary"
                class="ml-3"
                @click="checkCarregar(props.item)"
              >
                <span v-if="isSala">Carregar</span>
                <span v-else>Enviar</span>
              </v-btn>
            </template>
            <v-btn
              v-if="!consultaSomenteLeitura(props.item) && (isFullAdmin)"
              color="warning"
              class="ml-3"
              @click="perguntaReverterEnvio(props.item)"
            >
              Reverter Envio
            </v-btn>
          </td>
          <td v-if="props.item.evidencia">
            <app-modal-show-evidence
              :evidence="props.item.evidencia"
              :color="'primary'"
              :isHtml="isSala ? true : false"
            >
            </app-modal-show-evidence>
          </td>
          <td v-else></td>
          <td v-if="props.item.perguntaId == 3 && !criterio5Ativo">
            <v-btn
              color="azulclarosc"
              style="color: #fff"
              class="ml-3"
              @click="visualizarComplemento = !visualizarComplemento"
            >
              Complemento
            </v-btn>
          </td>
          <td v-else-if="props.item.perguntaId == 3"></td>
          <td
            v-else-if="
              props.item.perguntaId == 16 ||
              props.item.perguntaId == 17 ||
              props.item.perguntaId == 23
            "
            style="text-align: center; width: 150px"
          >
            <div>N. Atendentes informado</div>
            <div style="font-weight: bold; font-size: 16px">
              {{ valorDiagnosticoPergunta3 }}
            </div>
          </td>
        </tr>

        <tr
          class="complemento"
          v-if="visualizarComplemento && props.item.perguntaId == 3 && !criterio5Ativo"
        >
          <td colspan="8">
            <h1 class="titulo">Dados complementares obrigatórios</h1>
            <div>
              <!-- <div class="d-flex perguntas">
              <div class="_nome">
                Mínimo de horas por atendente informado no(s) arquivo(s)
                carregados acima
              </div>
              <div>
                <v-text-field
                  label=""
                  type="number"
                  v-model="props.item.valorInformado"
                  outlined
                  placeholder="0"
                  hide-details="auto"
                  disabled
                ></v-text-field>
              </div>
            </div> -->
              <hr />
              <div class="d-flex perguntas">
                <div class="_nome">
                  Quantidade de atendentes informada na
                  <strong>inscrição</strong>
                </div>
                <div>
                  <v-text-field
                    label=""
                    type="number"
                    v-model="valorDiagnostico"
                    outlined
                    placeholder="0"
                    hide-details="auto"
                    disabled
                  ></v-text-field>
                </div>
              </div>
              <hr />
              <div class="d-flex perguntas">
                <div class="_nome">
                  Nomes dos atendentes informados na inscrição
                </div>
                <div style="width: 50%">
                  <v-textarea
                    label=""
                    type="number"
                    v-model="valorNomeDiagnostico"
                    outlined
                    placeholder="0"
                    hide-details="auto"
                    disabled
                  ></v-textarea>
                </div>
              </div>
              <hr />

              <div class="d-flex perguntas">
                <div class="_nome">Quantidade atual de atendentes</div>
                <div>
                  <v-text-field
                    label=""
                    type="number"
                    v-model="props.item.atualizacaoAtendentes"
                    outlined
                    placeholder="0"
                    hide-details="auto"
                    disabled
                  ></v-text-field>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </template>
      <template v-slot:expanded-item="props">
        <tr
          v-if="!(criterio5Ativo && props.item.perguntaId == 3) && (
            isFullAdmin ||
            (groupsConfig.visualizarEvidenciadas && config.visualizarEvidenciadas)
          )"
        >
          <td colspan="8" class="p-0">
            <app-get-evidence-question
              :perguntaId="props.item.perguntaMunicipioId"
              @updateValue="$emit('updateValue')"
              :evidences="evidences"
              :type="'Evidenciadas'"
              @finalizar="openModal(props.item)"
             :readonly="consultaSomenteLeitura(props.item)"></app-get-evidence-question>
            <modal-finalizar
              @close="closeModal"
              :dialog="dialog"
              ref="modalFaixa"
              :itens="props.item"
              @finalizar="finalizarAvalicao"
            ></modal-finalizar>
          </td>
        </tr>
      </template>
      <template slot="no-data">
        <span> Nenhuma pergunta retornada </span>
      </template>
    </v-data-table>
    <modal-criterio5 v-model="dialogCriterio5" :pergunta="perguntaCriterio5"
      @finalizada="$emit('finalizarAnalise')" />
  </div>
</template>
<script>
import { criterio5API } from "./criterio5API";
import AppModalShowEvidence from "@/modules/diagnostic/components//ModalShowEvidence";
import { mapActions, mapGetters } from "vuex";
import AppGetEvidenceQuestion from "@/modules/evidence/components/selo/GetQuestionSelo";
import Swal from "sweetalert2";
import { evidenceQuestionAPI } from "@/modules/evidence/API/EvidenceQuestionAPI";
import { seloDiagnosticoRespostaAPI } from "@/modules/diagnosticoSelo/API/seloDiagnosticoRespostaAPI";
import ModalFinalizar from "./ModalFinalizar.vue";
import ModalCriterio5 from "./ModalCriterio5.vue";

import moment from "moment-timezone";
import { isWorkday } from "@/helpers/workingDay";
import { rulesFile } from "../utils";
import { cityQuestionAPI } from "@/modules/city";

import seloEvidenceReadScopeMixin from "@/utils/seloEvidenceReadScopeMixin";

export default {
  mixins: [seloEvidenceReadScopeMixin],
  components: {
    AppModalShowEvidence,
    AppGetEvidenceQuestion,
    ModalFinalizar,
    ModalCriterio5,
  },
  props: {
    visualizarPontosMedalha: { type: Boolean, required: true },
    perguntasEvidenciadas: { type: Array, required: true },
    headers: { type: Array, required: true },
    headersSemPontos: { type: Array, required: true },
    payload: { type: Object, Array: true },
    rulesArquivo: { type: Array, required: true },
    expanded: { type: Array, required: true },

    evidences: { type: Array },
  },
  data() {
    return {
      criterio5Ativo: false,
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      user: JSON.parse(localStorage.getItem("user")),
      visualizarComplemento: false,
      valorDiagnostico: 0,
      dialog: false,
      valorNomeDiagnostico: "",
      valorDiagnosticoPergunta3: 0,
      dialogCriterio5: false,
      perguntaCriterio5: null,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    abrirCriterio5(pergunta) {
      this.perguntaCriterio5 = pergunta;
      this.dialogCriterio5 = true;
    },
    getFileAccept(perguntaId) {
      switch (perguntaId) {
        case 12:
        case 13:
          return ".jpg, .jpeg, .png, .gif, .bmp, .webp"; // Apenas fotos
        case 14:
          return ".mp4, .avi, .mov, .wmv, .mkv, .webm, .flv"; // Apenas vídeos
        default:
          return "application/pdf, application/vnd.ms-excel"; // Apenas PDF e Excel
      }
    },
    getAllowedExtensions(perguntaId) {
      switch (perguntaId) {
        case 12:
        case 13:
          return [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp"];
        case 14:
          return [".mp4", ".avi", ".mov", ".wmv", ".mkv", ".webm", ".flv"];
        default:
          return [".pdf", ".xls", ".xlsx"];
      }
    },
    validateFiles(files, item) {
      if (!files || !files.length) return;
      const allowed = this.getAllowedExtensions(item.perguntaId);
      const invalid = files.filter((f) => {
        const ext = "." + f.name.split(".").pop().toLowerCase();
        return !allowed.includes(ext);
      });
      if (invalid.length) {
        this.$notification.error(
          `Arquivo(s) não permitido(s): ${invalid
            .map((f) => f.name)
            .join(", ")}. Extensões aceitas: ${allowed.join(", ")}`
        );
        item.arquivos = null;
      }
    },
    perguntasRespondidas3() {
      cityQuestionAPI
        .getPerguntaByPerguntaId(
          this.$route.params.id,
          3,
          this.uf,
          this.isParceiro,
          "prod"
        )
        .then((resp) => {
          console.log("resp.data: ", resp.data);
          this.valorDiagnosticoPergunta3 =
            resp.data.atualizacaoAtendentes || resp.data.inscricao?.resposta;
        })
        .catch((e) => {
          console.log("e: ", e);
        });
    },
    checkCarregar(pergunta) {
      const pdfRules = rulesFile(
        pergunta.perguntaId,
        pergunta.quantidadeArquivo,
        pergunta.quantidadeArquivoDadosComplementares,
        this.valorDiagnostico,
        pergunta.atualizacaoAtendentes,
        true
      );

      if (!pergunta.arquivos || pergunta.arquivos.length == 0) {
        this.$notification.error("Não há evidências a serem enviadas!");
        return;
      } else if (pdfRules) {
        this.$notification.error(pdfRules);
        pergunta.arquivos = null;
      } else {
        pergunta.perguntaId == 3
          ? this.$emit("sendEvidences", pergunta, false, true)
          : this.$emit("sendEvidences", pergunta, false, false);
      }
    },
    invalidEvidencias() {
      let aprovadas = this.evidences.filter((item) => item.aprovada);
      let rejeitadas = this.evidences.filter((item) => item.rejeitada);
      let respondidas = aprovadas.length + rejeitadas.length;

      if (this.evidences.length != respondidas) {
        Swal.fire({
          title: "Campos obrigatórios",
          text: `É necessário fazer a análise de todas as evidências antes de finaliza-las. Por favor verifique as evidências que faltam.`,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        });
        return true;
      }

      return false;
    },
    getRespostaDiagnostico() {
      this.setLoading(true);
      seloDiagnosticoRespostaAPI
        .getRespostaPergunta(26, this.$route.params.id)
        .then((resp) => {
          this.valorDiagnostico =
            resp.data && resp.data.length && resp.data[0].resposta;
        });
      this.setLoading(false);
    },
    getRespostaNomeDiagnostico() {
      this.setLoading(true);
      seloDiagnosticoRespostaAPI
        .getRespostaPergunta(27, this.$route.params.id)
        .then((resp) => {
          this.valorNomeDiagnostico = resp.data && resp.data[0].resposta;
        });
      this.setLoading(false);
    },
    untilDay() {
      let dayUtil = 2;
      let dayAtual = moment().tz("America/Sao_Paulo");

      while (dayUtil > 0) {
        dayAtual = moment(dayAtual).add(1, "days");

        if (isWorkday(dayAtual)) {
          dayUtil--;
        }
      }

      return dayAtual;
    },
    finalizarAvalicao(faixa) {
      this.setLoading(true);

      const a = this.evidences
        .filter((item) => !item.enviada)
        .map((val) => ({
          aprovada: val.aprovada,
          perguntaMunicipioId: val.perguntaMunicipioId,
          nomeArquivo: val.nomeArquivo,
          rejeitada: val.rejeitada,
          enviada: val.enviada,
          justificativa: val.justificativa,
          usuarioId: val.usuarioId,
          perguntaFaixaRespostaId: faixa.faixaId,
          prazoReenvio: this.untilDay(),
          perguntaEvidenciaId: val.perguntaEvidenciaId,
        }));

      evidenceQuestionAPI
        .finalizarAnalise(a)
        .then(() => {
          this.$emit("finalizarAnalise");
          this.dialog = false;
        })
        .catch((err) => {
          this.dialog = false;
          console.log("err: ", err);
          this.$notification.error(
            "Não foi possível finalizar a avaliação. Tente novamente."
          );
        })
        .finally(() => {
          this.setLoading(false);
        });
    },
    openModal(item) {
      if (this.invalidEvidencias()) return;

      this.dialog = true;
    },

    closeModal() {
      this.dialog = false;
    },
    perguntaReverterEnvio(pergunta) {
      Swal.fire({
        title: "Reverter Envio!",
        text: `Ao reverter o envio, a pergunta voltará ao estado não respondida. Deseja continuar?`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Não",
        confirmButtonText: "Sim",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.reverterEnvio(pergunta);
        }
      });
    },
    reverterEnvio(pergunta) {
      this.setLoading(true);
      cityQuestionAPI
        .revertarEnvio(pergunta.perguntaMunicipioId)
        .then(() => {
          this.$emit("updateValue");
        })
        .catch((err) => {
          console.log("Error on evidenciadaselo reverterenvio");
          this.setLoading(false);
          this.$notification.error("Erro em reverter envio");
        });
    },
  },
  mounted() {
    criterio5API.configuracao().then(({ data }) => { this.criterio5Ativo = data.habilitado; })
      .catch(() => { this.$notification.error("Não foi possível verificar o modo de avaliação do Critério 05."); });
    this.getRespostaDiagnostico();
    this.getRespostaNomeDiagnostico();
    this.perguntasRespondidas3();
  },
  computed: {
    ...mapGetters([
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isADMunicipio",
      "isAuthenticated",
      "uf",
      "logo",
      "isSala",
      "isAnalista",
      "isFullAdmin",
      "isParceiro",
    ]),
  },
};
</script>
<style>
.complemento .v-input__control {
  background: #fff;
}

.pergunta3 .v-file-input__text {
  color: #fff !important;
}
.pergunta3 .v-text-field .v-label {
  color: #f5f5f5 !important;
}
</style>
<style scoped lang="scss">
.evidencias {
  padding: 10px 30px !important;
  .titulo2 {
    font-size: 16px;
    margin-bottom: 10px;
  }
  .nomeEvidencia {
    cursor: pointer;
    color: #2d6189;
    font-weight: bold;
  }

  .nomeEvidencia:not(:last-of-type) {
    border-right: 1px solid #dfdfdf;
    padding-right: 20px;
  }

  .agrupEvidencias {
    display: flex;
    flex-wrap: wrap;
    column-gap: 20px;
    row-gap: 20px;
  }
}

.pergunta3 {
  background: #2d6189;
  color: #fff;
}
.pergunta3:hover {
  background: #3d6788 !important;
  color: #fff;
}
.complemento {
  background: #f5f5f5;
}
.complemento td {
  padding: 10px 30px !important;
}
.titulo {
  font-size: 20px;
  margin: 1rem 0;
}
.perguntas {
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin: 1rem 0;

  ._nome {
    max-width: 70%;
  }
}
</style>
